import React, { useState, Suspense } from 'react';
import NavBar from './Components/Frames/NavBar';
import Modal from "./Components/Global/Modal";
import DeclarationModal from './Components/Global/DeclarationModal';
import LandingPage from "./Components/Frames/LandingPage";
import AboutPage from "./Components/Frames/AboutPage";
import PortfolioPage from "./Components/Frames/PortfolioPage";
// import ContactPage from './Components/Frames/ContactPage'; // Currently commented out
import './CSS/App.css';

function App() {

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const modalTrigger = (content:any, show:boolean) => {
    setShowModal((prev:boolean) => !prev);
    setModalContent(content);
    document.body.style.overflow = show ? "hidden" : "" 
  }

  return (
    <div className="App">
      
      <NavBar />

      <Modal show={showModal} setShowModal={modalTrigger}>
        <Suspense fallback={<div style={{padding: '2rem', textAlign: 'center'}}>Loading...</div>}>
          {modalContent}
        </Suspense>
      </Modal>

      <div className="wrapper">
        <button onClick={() => modalTrigger(<DeclarationModal />, showModal)}>About This Site</button>
      </div>

      <div className="App-body">

        <div className="Frame" id="Phantom">
          NAVBAR GAP
        </div>

        <div className="Frame" id="LandingPage">
          <LandingPage />
        </div>

        <div className="Frame" id="AboutPage">
          <AboutPage showModal={showModal} modalTrigger={modalTrigger} />
        </div>

        <div className="Frame" id="PortfolioPage">
          <PortfolioPage showModal={showModal} modalTrigger={modalTrigger} />
        </div>

        {/*
        <div className="Frame" id="ContactPage">
          <ContactPage showModal={showModal} modalTrigger={modalTrigger} />
        </div>
        */}
          
      </div>
      
    </div>
  );
}

export default App;
